import Paper from '@material-ui/core/Paper';
import { styled } from '@material-ui/core/styles';

export default styled(Paper)(({ theme }) => ({
  margin: theme.spacing(2, 0),
  padding: theme.spacing(1),
  [theme.breakpoints.up('xs')]: {
    padding: theme.spacing(2),
  },
}));
